export default "<img #map src=\"{{locationURL}}\" *ngIf=\"locationURL\">";